import { render, staticRenderFns } from "./apply_payment_traffic_edit.vue?vue&type=template&id=6870d10a&scoped=true&"
import script from "./apply_payment_traffic_edit.vue?vue&type=script&lang=js&"
export * from "./apply_payment_traffic_edit.vue?vue&type=script&lang=js&"
import style0 from "./apply_payment_traffic_edit.vue?vue&type=style&index=0&id=6870d10a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870d10a",
  null
  
)

export default component.exports